/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PipesModule} from '../../../shared/pipes/pipes.module';
import {SettlementRejectMotivationComponent} from './settlement-reject-motivation.component';

@NgModule({
    declarations: [SettlementRejectMotivationComponent],
    imports: [
        CommonModule,
        PipesModule
    ],
    exports: [
        SettlementRejectMotivationComponent
    ]
})
export class SettlementRejectMotivationModule {
}
